import { h } from 'preact';
import { useState, useMemo, useEffect } from "preact/hooks";

const CartLoyalty = ({ cart, perks, perksLoggedIn, perksBg, perksColor, threshold, points }) => {
  const [customerDetails, setCustomerDetails] = useState(null);
  const [countPoints, setCountPoints] = useState(Math.floor(cart.state.total_price * (points.pointPrice / 100)));
  const [loggedInMessage, setLoggedInMessage] = useState(perksLoggedIn.replace('[points]', `<span class='bg-white rounded px-1 font-bold leading-[18px]'>${points.pointMarkupLogin}</span>`).replace('[points]', countPoints));
  const [loggedOutMessage, setLoggedOutMessage] = useState(perks.replace('[points]', `<span class='bg-white rounded px-1 font-bold leading-[18px]'>${points.pointMarkup}</span>`).replace('[points]', countPoints));

  useEffect(() => {
    //poins calculation
    setLoggedInMessage(perksLoggedIn.replace('[points]', `<span class='bg-white rounded px-1 font-bold leading-[18px]'>${points.pointMarkupLogin}</span>`).replace('[points]', Math.floor(cart.state.total_price * (points.pointPrice / 100))));
    setLoggedOutMessage(perks.replace('[points]', `<span class='bg-white rounded px-1 font-bold leading-[18px]'>${points.pointMarkup}</span>`).replace('[points]', Math.floor(cart.state.total_price * (points.pointPrice / 100))));
  }, [cart.state.total_price]);

  document.addEventListener('swell:setup', () => {
    setCustomerDetails(window?.swellAPI?.getCustomerDetails())
  });

  const style = {
    ...(perksColor && { color: perksColor }),
    ...(perksBg && { background: perksBg })
  };

  useEffect(() => {
    // we have to update customer details when cart changed 
    setCustomerDetails(window?.swellAPI?.getCustomerDetails())
  }, [cart.lines])

  const states = useMemo(() => {
    return {
      LoggedIn: (<div style={style} className={`text-center body-xs  py-2.5 px-5  ${perksBg ? '' : 'bg-sky-blue'} ${perksColor ? '' : 'text-grey-2A [&_a]:text-grey-2A'}`} dangerouslySetInnerHTML={{ __html: loggedInMessage }}></div>),
      LoggedOut: (<div style={style} className={`text-center body-xs  py-2.5 px-5  ${perksBg ? '' : 'bg-sky-blue'} ${perksColor ? '' : 'text-grey-2A [&_a]:text-grey-2A'}`} dangerouslySetInnerHTML={{ __html: loggedOutMessage }}></div>)
    }
  }, [customerDetails?.email, cart.lines, loggedInMessage, loggedOutMessage, countPoints]);
  return (
    states[customerDetails?.email ? 'LoggedIn' : 'LoggedOut']
  )
}

export default CartLoyalty
